import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { selectUser } from "store/user/selectors";
import { setSelectedLevel } from "store/game";
import useLoader from "hooks/useLoader";
import { twMerge } from "tailwind-merge";
import Lottie from "lottie-react";
import LoadingLottieData from "assets/lotties/search-loading.json";
import Button from "components/Button";
import Alert from "components/Alert";

export default function Load() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const { isLoading, isLoadingImages, imagesProgress, error, setError } =
    useLoader({
      onLoad: () => {
        navigate("/playground", {
          replace: true,
        });
      },
      disabled: Boolean(location.state?.level),
    });

  useEffect(() => {
    if (location.state?.level) {
      dispatch(setSelectedLevel(location.state?.level));
      location.state.level = null;
    }
  }, [dispatch, location.state?.level]);

  if (!user.username) {
    return <Navigate to="/" />;
  }

  if (isLoading || isLoadingImages) {
    return (
      <div className="flex flex-grow justify-center items-center">
        <div className="flex items-center flex-col gap-4">
          <Lottie
            animationData={LoadingLottieData}
            style={{ height: "80px" }}
          />
          <div
            className={twMerge(
              "text-lg",
              isLoadingImages
                ? "animate-fade-in visible"
                : "animate-fade-out hidden"
            )}
          >
            Şəkillər yüklənir... {imagesProgress}%
          </div>
          <div
            className={twMerge(
              "text-lg",
              isLoading ? "animate-fade-in visible" : "animate-fade-out hidden"
            )}
          >
            Məhsullar yüklənir...
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex-grow flex flex-col gap-3 items-center justify-center">
        <Alert className="max-w-sm text-center" type="error">
          {error}
        </Alert>
        <Button
          onClick={() => {
            dispatch(setSelectedLevel(null));
            setError(null);
          }}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
          Geri
        </Button>
      </div>
    );
  }

  return null;
}
